import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { isColorDropTarget } from '@/lib/colors/is-color-drop-target'
import { expandTransparencyShapeTargets } from '@/lib/object-effects/expand-transparency-targets'

/**
 * The shapes a fill color actually lands on when applied to `roots`: a group stands for every
 * leaf member under it (nested groups included), and locked shapes and shapes that can't take a
 * fill (`isColorDropTarget`) are skipped. Shared by the fill picker and drag-and-drop, so a color
 * picked for a selected group and one dropped on it recolor the same shapes.
 */
export function colorFillTargets(roots: ShapeData[], allShapes: ShapeData[]): ShapeData[] {
  const byId = new Map(allShapes.map((s) => [s.id, s]))

  return expandTransparencyShapeTargets(roots, allShapes)
    .filter((t) => !t.locked)
    .map((t) => byId.get(t.id))
    .filter((s): s is ShapeData => s != null && isColorDropTarget(s))
}
